export default __webpack_public_path__ + "static/media/et.6e43c493.svg";